var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"org"},[_c('header',{staticClass:"header"},_vm._l((_vm.componentLs),function(item,index){return _c('span',{key:index,class:['tag',_vm.$route.path === item.path?'active':''],on:{"click":function($event){return _vm.handleChange(item)}}},[_vm._v(_vm._s(item.title))])}),0),_c('div',{staticClass:"main-box"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }